import { ElementType } from 'react'

import { BrainIcon, FilesIcon, HouseIcon, IconProps, InvoiceIcon, PackageIcon, UserIcon } from '@phosphor-icons/react'
import { UsersThreeIcon } from '@phosphor-icons/react/dist/ssr'
import { MotionProps } from 'framer-motion'

export type MenuSubItem = {
  id: string
  name: string // Key to translate
  path: string
}

export type MenuItem = MotionProps & {
  id: string
  icon: ElementType<IconProps>
  name: string // Key to translate
  path: string
  items?: MenuSubItem[]
  visibleDesktop: boolean
  visibleMobile: boolean
}

export const MenuItems: MenuItem[] = [
  {
    id: 'dashboard',
    icon: HouseIcon,
    name: 'Dashboard',
    path: '/',
    visibleDesktop: true,
    visibleMobile: true,
  },
  {
    id: 'zeca',
    icon: BrainIcon,
    name: 'Zeca (IA)',
    path: '/zeca',
    visibleDesktop: true,
    visibleMobile: true,
  },
  {
    id: 'employees',
    icon: UsersThreeIcon,
    name: 'Meus colaboradores',
    path: '/employees',
    visibleDesktop: true,
    visibleMobile: true,
  },
  {
    id: 'return-taxes',
    icon: FilesIcon,
    name: 'Guias de impostos',
    path: '/return-taxes',
    visibleDesktop: true,
    visibleMobile: true,
  },
  {
    id: 'products',
    icon: PackageIcon,
    name: 'Produtos',
    path: '/products',
    visibleDesktop: false,
    visibleMobile: false,
  },
  {
    id: 'invoices',
    icon: InvoiceIcon,
    name: 'Notas fiscais',
    path: '/invoices',
    visibleDesktop: false,
    visibleMobile: false,
  },
  {
    id: 'profile',
    icon: UserIcon,
    name: 'Meu perfil',
    path: '/profile',
    visibleDesktop: false,
    visibleMobile: true,
  },
]
